import React from 'react';
import clsx from 'clsx';
import { Navigate, Route, Routes, useParams } from 'react-router-dom';

import {
  getConsolidatedForecastPredictionsUrl,
  PREDICT_PRODUCT_SLUG,
  ROUTES
} from '@futrli/shared-services';

import { ConsolidationAssets } from '../assets/consolidation-assets';
import { ConsolidationBalanceSheet } from '../balance-sheet/consolidation-balance-sheet';
import { ConsolidationCashFlowStatement } from '../cash-flow-statement/consolidation-cash-flow-statement';
import { ConsolidationCosts } from '../costs/consolidation-costs';
import { ConsolidationExpenses } from '../expenses/consolidation-expenses';
import { ConsolidationLiabilities } from '../liabilities/consolidation-liabilities';
import { ConsolidationOtherPL } from '../other-pl/consolidation-other-pl';
import { ConsolidationProfitAndLoss } from '../profit-and-loss/consolidation-profit-and-loss';
import { ConsolidationSales } from '../sales/consolidation-sales';
import { Invoices } from '../invoices/invoices';

import styles from './predictions-nav-data-controls.scss';

const CONSOLIDATION_PREDICTION_ROUTES = [
  {
    route: ROUTES.INVOICES,
    routeComponent: Invoices
  },
  {
    route: ROUTES.SALES,
    routeComponent: ConsolidationSales
  },
  {
    route: ROUTES.COSTS,
    routeComponent: ConsolidationCosts
  },
  {
    route: ROUTES.EXPENSES,
    routeComponent: ConsolidationExpenses
  },
  {
    route: ROUTES.OTHER_P_AND_L,
    routeComponent: ConsolidationOtherPL
  },
  {
    route: ROUTES.ASSETS,
    routeComponent: ConsolidationAssets
  },
  {
    route: ROUTES.LIABILITIES,
    routeComponent: ConsolidationLiabilities
  },
  {
    route: ROUTES.PROFIT_AND_LOSS,
    routeComponent: ConsolidationProfitAndLoss
  },
  {
    route: ROUTES.BALANCE_SHEET,
    routeComponent: ConsolidationBalanceSheet
  },
  {
    route: ROUTES.CASH_FLOW_STATEMENT,
    routeComponent: ConsolidationCashFlowStatement
  }
];

export const ConsolidationPredictionsRouterUK = () => {
  const { workspaceId, organisationId, forecastId } = useParams();
  return (
    <div className={clsx(styles.content, styles.pageWidthWrapper)}>
      <Routes>
        {CONSOLIDATION_PREDICTION_ROUTES.map(({ route, routeComponent: RouteComponent }) => (
          <Route key={route} path={route} element={<RouteComponent />} />
        ))}
        <Route
          path="*"
          element={
            <Navigate
              to={`${getConsolidatedForecastPredictionsUrl(
                workspaceId!,
                organisationId!,
                PREDICT_PRODUCT_SLUG,
                forecastId!
              )}${ROUTES.SALES}`}
            />
          }
        />
      </Routes>
    </div>
  );
};
